const { keyMirror } = window.Edocat.Utils;

export default keyMirror(['SET_ROUTES', 'CHANGE_ROUTE']);
